export default __webpack_public_path__ + "static/media/button-try-now.4e63b006.svg";